import Button from '../common/Button';
import ErrorMessage from '../common/ErrorMessage';
import Input from '../common/Input';
import './AuthForm.scss';
import AuthFormFooter from './AuthFormFooter';

const textMap = {
  login: '로그인',
  register: '회원가입',
};

const AuthForm = ({ type, form, onChange, onSubmit, error }) => {
  const text = textMap[type];
  return (
    <div className="AuthForm">
      <h3>{text}</h3>
      <form onSubmit={onSubmit}>
        <Input
          autoComplete="username"
          name="username"
          placeholder="아이디"
          onChange={onChange}
          value={form.username}
        />
        <Input
          autoComplete="new-password"
          name="password"
          placeholder="비밀번호"
          type="password"
          onChange={onChange}
          value={form.password}
        />
        {type === 'register' && (
          <Input
            autoComplete="new-password"
            name="passwordConfirm"
            placeholder="비밀번호 확인"
            type="password"
            onChange={onChange}
            value={form.passwordConfirm}
          />
        )}
        {error && <ErrorMessage error={error} />}
        <Button blue fullWidth style={{ marginTop: '1rem' }}>
          {text}
        </Button>
      </form>
      <AuthFormFooter
        to={type === 'login' ? '/register' : '/login'}
        text={type === 'login' ? '회원가입' : '로그인'}
      />
    </div>
  );
};

export default AuthForm;
